import { render, staticRenderFns } from "./heroslider.vue?vue&type=template&id=6445acf1&scoped=true&"
import script from "./heroslider.vue?vue&type=script&lang=js&"
export * from "./heroslider.vue?vue&type=script&lang=js&"
import style0 from "./heroslider.vue?vue&type=style&index=0&id=6445acf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445acf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6445acf1', component.options)
    } else {
      api.reload('6445acf1', component.options)
    }
    module.hot.accept("./heroslider.vue?vue&type=template&id=6445acf1&scoped=true&", function () {
      api.rerender('6445acf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/heroslider.vue"
export default component.exports